import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { copyToClipboard } from 'utils/common';
import { type DetailProps } from './types';

export const Detail = ({
  icon: Icon,
  title,
  value,
  link,
  className,
}: DetailProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  const handleCopyLink = (): void => {
    if (!link) return;
    copyToClipboard(link);
    toast.success(t('Common.CopyToClipboard.success', { ns: LOCIZE_NS.COMMON }));
  };

  return (
    <div className="flex gap-2">
      {Icon && (
        <Icon
          height={40}
          width={40}
          className="text-denim-600 bg-teal-100 p-2 rounded-2xl shrink-0"
        />
      )}
      <div className="flex-1 min-w-0">
        {title && <p className="text-xs text-gray-600">{title}</p>}
        {link ? (
          <Button
            variant="link"
            onClick={handleCopyLink}
            className={cn(
              'p-1 text-sm text-gray-600 font-normal text-left hover:underline',
              'w-full whitespace-normal line-clamp-2 items-start h-fit',
              'justify-start',
              className
            )}
          >
            {link}
          </Button>
        ) : (
          <p className={cn('text-sm text-gray-600 whitespace-pre-line', className)}>{value}</p>
        )}
      </div>
    </div>
  );
};
